/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 10.06.17.
 */

import alt from "../alt";

class LogActions {
    debug(message) {
        return message;
    }

    info(message) {
        return message;
    }

    warn(message) {
        return message;
    }

    error(message) {
        return message;
    }

    exception(e) {
        return e;
    }

    clientError(status, message) {
        return {
            status: status,
            message: message
        };
    }

    clearError() {
        return null;
    }
}

/**
 *
 * @type {LogActions}
 */
let logActions = alt.createActions(LogActions);
export default logActions;
